/**
|--------------------------------------------------------------------------
| Vue Component : Footer
|--------------------------------------------------------------------------
|
| Usage : This Component used for
| Created By rahul on (24 Feb 2022 at 12:16 PM)
|
*/
<template>

  <footer class="page-footer">
    <div class="container">
      <span class="line"></span>
      <div class="row align-items-center">
        <div class="col-md-3 footer-logo-bar">
          <a href="."><img src="../../../public/images/logo.svg" alt="Ezamani Logo"></a>
        </div>
        <div class="col-md-6 menu-container">
          <nav class="row justify-content-center m-0">
            <ul class="menu">
              <li> <router-link to="/homr">{{ $t('route.home') }}</router-link></li>
              <li> <router-link to="/about">{{ $t('route.about') }}</router-link></li>
              <li> <router-link to="/vendors">{{ $t('route.vendors') }}</router-link></li>
              <li><router-link to="/contact">{{ $t('route.contact') }}</router-link></li>
              <li><router-link to="/terms-and-conditions">{{ $t('route.terms-and-conditions') }}</router-link></li>
              <li v-if="!isAuthenticated"><router-link   to="/login">{{ $t('route.login') }}</router-link></li>

            </ul>
          </nav>
        </div>
        <div class="col-md-3">
          <ul class="social">
            <li>
              <a href="#">
                <svg width="10" height="19" viewBox="0 0 10 19" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M2.4069 18.8456V10.4112H0V7.37441H2.4069V4.78061C2.4069 2.74237 3.82867 0.870605 7.10472 0.870605C8.43114 0.870605 9.41196 0.988431 9.41196 0.988431L9.33468 3.82427C9.33468 3.82427 8.33439 3.81524 7.24284 3.81524C6.06144 3.81524 5.87217 4.31971 5.87217 5.157V7.37441H9.42859L9.27384 10.4112H5.87217V18.8456H2.4069Z"
                      fill="#333333" />
                </svg>
              </a>
            </li>
            <li>
              <a href="#">
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M15.7119 5.1394C15.7119 4.53749 15.2001 4.05148 14.571 4.05148C13.9419 4.05148 13.4297 4.53749 13.4297 5.1394C13.4297 5.73909 13.9419 6.2251 14.571 6.2251C15.2001 6.2251 15.7119 5.73909 15.7119 5.1394Z"
                      fill="#333333" />
                  <path
                      d="M17.2319 13.632C17.1896 14.515 17.0347 14.9948 16.906 15.3134C16.7333 15.7359 16.5272 16.0379 16.1929 16.3548C15.8624 16.6717 15.5454 16.8677 15.1022 17.0306C14.768 17.155 14.2628 17.3031 13.3365 17.3452C12.3351 17.3873 12.0383 17.3962 9.49882 17.3962C6.96168 17.3962 6.66259 17.3873 5.66116 17.3452C4.73487 17.3031 4.23204 17.155 3.89773 17.0306C3.4522 16.8677 3.13765 16.6717 2.80524 16.3548C2.47048 16.0379 2.26439 15.7359 2.09396 15.3134C1.96529 14.9948 1.80804 14.515 1.76811 13.632C1.7193 12.6774 1.71036 12.3901 1.71036 9.97436C1.71036 7.55367 1.7193 7.26857 1.76811 6.31398C1.80804 5.43103 1.96529 4.95172 2.09396 4.63037C2.26439 4.20836 2.47048 3.90806 2.80524 3.5912C3.13765 3.27482 3.4522 3.07833 3.89773 2.91366C4.23204 2.7888 4.73487 2.6429 5.66116 2.60084C6.66259 2.55875 6.96168 2.54801 9.49882 2.54801C12.0383 2.54801 12.3351 2.55875 13.3365 2.60084C14.2628 2.6429 14.768 2.7888 15.1022 2.91366C15.5454 3.07833 15.8624 3.27482 16.1929 3.5912C16.5272 3.90806 16.7333 4.20836 16.906 4.63037C17.0347 4.95172 17.1896 5.43103 17.2319 6.31398C17.2783 7.26857 17.2896 7.55367 17.2896 9.97436C17.2896 12.3901 17.2783 12.6774 17.2319 13.632ZM18.9423 6.2397C18.8958 5.27482 18.7361 4.6156 18.499 4.04144C18.2577 3.44577 17.9342 2.94095 17.4046 2.43614C16.8774 1.93357 16.3478 1.62521 15.7229 1.39251C15.1182 1.16873 14.429 1.01477 13.4163 0.97271C12.4036 0.926157 12.0801 0.917664 9.49882 0.917664C6.91989 0.917664 6.59407 0.926157 5.58137 0.97271C4.57099 1.01477 3.88224 1.16873 3.27473 1.39251C2.65218 1.62521 2.12259 1.93357 1.59536 2.43614C1.06577 2.94095 0.742271 3.44577 0.498604 4.04144C0.263844 4.6156 0.104228 5.27482 0.0553887 6.2397C0.0112679 7.20503 0 7.51382 0 9.97436C0 12.4326 0.0112679 12.741 0.0553887 13.7063C0.104228 14.6694 0.263844 15.3282 0.498604 15.905C0.742271 16.4985 1.06577 17.0055 1.59536 17.5081C2.12259 18.0107 2.65218 18.3213 3.27473 18.5535C3.88224 18.7773 4.57099 18.9295 5.58137 18.9738C6.59407 19.0181 6.91989 19.0288 9.49882 19.0288C12.0801 19.0288 12.4036 19.0181 13.4163 18.9738C14.429 18.9295 15.1182 18.7773 15.7229 18.5535C16.3478 18.3213 16.8774 18.0107 17.4046 17.5081C17.9342 17.0055 18.2577 16.4985 18.499 15.905C18.7361 15.3282 18.8958 14.6694 18.9423 13.7063C18.9887 12.741 19 12.4326 19 9.97436C19 7.51382 18.9887 7.20503 18.9423 6.2397Z"
                      fill="#333333" />
                  <path
                      d="M9.49967 12.99C7.75175 12.99 6.3334 11.6402 6.3334 9.97403C6.3334 8.30519 7.75175 6.95367 9.49967 6.95367C11.2481 6.95367 12.6683 8.30519 12.6683 9.97403C12.6683 11.6402 11.2481 12.99 9.49967 12.99ZM9.49967 5.32108C6.80525 5.32108 4.62305 7.40565 4.62305 9.97403C4.62305 12.5402 6.80525 14.6226 9.49967 14.6226C12.1941 14.6226 14.3787 12.5402 14.3787 9.97403C14.3787 7.40565 12.1941 5.32108 9.49967 5.32108Z"
                      fill="#333333" />
                </svg>

              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="copy-right">
        <p>© {{$moment().year()}} Ezamani. All rights reserved</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterView",
  computed : {
    isAuthenticated : function(){ return this.$store.getters.isAuthenticated},
    userName : function(){ return this.$store.getters.StateUser.name},
  },
}
</script>

<style scoped>

</style>